module.exports = __webpack_public_path__ + "ee65bd6b59c051ac4cac13149127f330.svg";